import { checkResolution } from 'Functions/helpers'
import { disableScroll, enableScroll } from 'Functions/scroll-lock'
import "lightgallery/src/js/lightgallery.js"
import "lightgallery/modules/lg-video"
import "lightgallery/modules/lg-thumbnail"
import "lightgallery/modules/lg-zoom"
import "lightgallery/modules/lg-hash"

document.addEventListener('DOMContentLoaded', () => {
    const $ = window.jQuery;

    $('.js-lightbox-holder').each((index, lightboxHolder) => {
        const options = {
            hideBarsDelay: 0,
            autoplay: false,
            autoplayControls: false,
            download: false,
            share: false,
            fullScreen: false,
            videoMaxWidth: "1140px",
            iframeMaxWidth: "100%",
            enableDrag: true,
            enableTouch: true,
            zoom: true,
            closable: false,
            thumbnail: typeof $(lightboxHolder).data('thumbnail') !== 'undefined' ? $(lightboxHolder).data('thumbnail') : true,
            thumbWidth: 80,
            thumbContHeight: 120,
            thumbMargin: 10,
            selector: '.js-lightbox',
            exThumbImage: 'data-thumb',
            galleryId: lightboxHolder.id,
            hash: true,
        }

        if (checkResolution('cxs;txs')) {
            options.thumbWidth = 60
            options.thumbContHeight = 80
            options.thumbMargin = 10
        }

        $(lightboxHolder).lightGallery(options);

        $(lightboxHolder).on('onBeforeOpen.lg', (event) => {
            window.onhashchange = () => {}
        });

        $(lightboxHolder).on('onAfterOpen.lg', (event) => {
            disableScroll()
        });

        $(lightboxHolder).on('onBeforeClose.lg', () => {
            enableScroll()
            history.replaceState('', document.title, `${window.location.pathname}${window.location.search}`)
        });
    })

    $('.js-lightbox-trigger').on('click', function(event) {
        event.preventDefault();

        const $lightboxHolder = $(`.js-lightbox-holder#${$(this).data('gallery-id')}`);

        if (!$lightboxHolder.length || $(this).data('query') && !checkResolution($(this).data('query'))) {
            return
        }

        if ($(this).data('video')) {
            $lightboxHolder.find('.js-lightbox.is-video').click();
        }
        else {
            $lightboxHolder.find('.js-lightbox:not(.is-video)').eq(this.dataset.index).click();
        }
    });
})
